import { Protocol } from "./_types";

export const LIB_PROTOCOL_POMEGRANATE_TREE_SCREEN_EVAL: Protocol = {
    id: "pomegranate_tree_screen_eval",
    title: "Advanced Pomegranate Tree Evaluation",
    description: "Tree Evaluation is performed to characterise the adaptability of cultivars and selections on the base of a full set of tree characteristics and includes all phenological stages. Characteristics such as growth and architecture, flowering and fruit set, pests and diseases and general adaptability are evaluated in detail.",
    sampleType: "plant",

    chars: [
        "date_harvest_start",
        "date_harvest_end",
    ],

    measures: [
        "tree_trunk_circum",
        "tree_trunk_diameter",
    ],

    calculations: [],

    indexes: [],

}